import { CountResponse } from '@interfaces/common.interface';
import {
  ActivateUserRequest,
  CountUsersRequestParams,
  CreatePasswordlessUserRequest,
  GetUsersRequestParams,
  RequestUserActivationRequest,
  UpdateCurrentUserRequest,
  UpdateUserRequest,
  User,
  UserWithPermissions,
} from '@interfaces/users.interface';

import api from './';

export const {
  useRequestActivationMutation,
  useVerifyActivationTokenQuery,
  useActivateMutation,
  useUpdateCurrentUserMutation,
  useGetUserByIdQuery,
  useCountUsersQuery,
  useGetManyUsersQuery,
  useCreatePasswordlessUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    requestActivation: build.mutation<void, RequestUserActivationRequest>({
      query: (body) => ({
        url: `users/activate/request`,
        method: 'POST',
        body,
      }),
    }),
    verifyActivationToken: build.query<void, string>({
      query: (token) => ({
        url: `users/activate/${token}`,
        method: 'GET',
      }),
    }),
    activate: build.mutation<void, ActivateUserRequest>({
      query: ({ token, body }) => ({
        url: `users/activate/${token}`,
        method: 'POST',
        body,
      }),
    }),
    updateCurrentUser: build.mutation<
      UserWithPermissions,
      UpdateCurrentUserRequest
    >({
      query: (body) => ({
        url: 'users/current',
        method: 'PATCH',
        body,
      }),
    }),
    getUserById: build.query<UserWithPermissions, string>({
      query: (id) => ({ url: `users/${id}` }),
      providesTags: ['users'],
    }),
    countUsers: build.query<CountResponse, CountUsersRequestParams>({
      query: (params) => ({ url: 'users/count', params }),
      providesTags: ['users'],
    }),
    getManyUsers: build.query<User[], GetUsersRequestParams>({
      query: (params) => ({ url: 'users', params }),
      providesTags: ['users'],
    }),
    createPasswordlessUser: build.mutation<User, CreatePasswordlessUserRequest>(
      {
        query: (body) => ({
          url: `users`,
          method: 'POST',
          body,
        }),
        invalidatesTags: ['users'],
      },
    ),
    updateUser: build.mutation<User, UpdateUserRequest>({
      query: ({ id, body }) => ({
        url: `users/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: [
        'users',
        'medicalOrganizations',
        'medicalDoctors',
        'patients',
      ],
    }),
    deleteUser: build.mutation<User, string>({
      query: (id) => ({
        url: `users/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['users'],
    }),
  }),
});
